export default __webpack_public_path__ + "static/Greycliffcf-regular-webfont-c410c4149ce0566ecf9c706391a25741.woff2";